const langEn = require ('./locales/en.json'); //use for meta tags
const langDe = require ('./locales/de.json');
module.exports = {
    lang: {en: langEn, de: langDe},
    dataRoutes: [
    {
        paths: {de: "", en: ""},
        component: () => import( '@/views/Home.vue'),
        name: 'home',
        icon: 'mdi-home',
        section: 'main-nav',
    },
    {
        paths: {de: "psychologische-beratung", en: "psychological-counseling"},
        component: () => import( '@/views/Psychology.vue'),
        name: 'psychology',
        icon: 'mdi-head-cog',
        section: 'main-nav'
    },
    {
        paths: {de: "intrapsychische-systemarbeit", en: "intrapsychic-systemwork"},
        component: () => import( '@/views/IPS.vue'),
        name: 'ips',
        icon: 'mdi-account-multiple',
        section: 'main-nav',
    },
    {
        paths: {de: "mutterschaft", en: "motherhood"},
        component: () => import( '@/views/Motherhood.vue'),
        name: 'motherhood',
        icon: 'mdi-mother-heart',
        section: 'main-nav',
    },
    {
        paths: {de: "yoga", en: "yoga"},
        component: () => import( '@/views/Yoga.vue'),
        name: 'yoga',
        icon: 'mdi-yoga',
        section: 'main-nav',
    },
    {
        paths: {de: "ueber-mich", en: "about-me"},
        component: () => import( '@/views/AboutMe.vue'),
        name: 'about-me',
        icon: 'mdi-human-female',
        section: 'main-nav',
    },
    {
        paths: {de: "impressum", en: "impress"},
        component: () => import( '@/views/Impress.vue'),
        name: 'impress',
        section: 'footer-nav',
        priority: 0.8
    },
    {
        paths: {de: "datenschutzerklaerung", en: "privacy-policy"},
        component: () => import( '@/views/PrivacyPolicy.vue'),
        name: 'privacy-policy',
        section: 'footer-nav',
        priority: 0.8
    }],
    sitemapRoutes() {
        var dt = new Date();
        const today = dt.getFullYear() + "/" + (dt.getMonth() + 1) + "/" + dt.getDate();
        const routes = [
            ...this.configsByLocale('en'),
            ...this.configsByLocale('de')
            ]
            .filter(r => r.path !== '*')
            .map(r => {
                return {
                    path: '/' + r.locale + '/' + r.path,
                    lastmod: today,
                    priority: r.priority || 1,
                    changefreq: 'monthly'
                }
            })
        routes.unshift({
            path: '',
            lastmod: today,
            priority: 1,
            changefreq: 'monthly'
        });
        return routes;
    },
    configsByLocale(locale) {
        return this.dataRoutes.map(child => {
            const alias = [];
            for (let alocale in child.paths || []) {
                if(alocale !== locale) {
                    alias.push(child.paths[alocale])
                }
            }
            return {
                paths: child.paths,
                path: child.paths[locale],
                component: child.component,
                name: child.name,
                locale: locale,
                alias: alias,
                section: child.section,
                icon: child.icon || 'mdi-home',
                priority: child.priority || 1
            };
        })
    }
};
